import { createSelector } from "reselect";

import { ILoginUserData, ICurrentHover, ILockedModal } from "../Models/Models";
import { IRootReducer } from "../Reducers/RootReducer";

export const loginSelector = createSelector(
    (state: IRootReducer) => (
        {
            firstName: state.loginReducer.firstName,
            lastName: state.loginReducer.lastName,
            initials: state.loginReducer.initials,
            featureAccess: state.loginReducer.featureAccess,
            userID: state.loginReducer.userID,
        }
    ),
    (data: ILoginUserData) => data
);

export const fetchingLoginUserDataSelector = createSelector(
    (state: IRootReducer) => state.loginReducer.fetchingLoginUserData,
    (loading: boolean) => loading
);

export const currentHoverSelector = createSelector(
    (state: IRootReducer) => state.loginReducer.currentHover,
    (currentHover: ICurrentHover) => currentHover
);

export const lockedModalSelector = createSelector(
    (state: IRootReducer) => state.loginReducer.lockedModal,
    (lockedModal: ILockedModal) => lockedModal
);
